export default __webpack_public_path__ + "static/media/NationalGeographic.418ddeb0.png";